var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8117 22.0447C13.3098 22.0053 13.8113 21.9281 14.3127 21.8111C19.3853 20.6273 22.653 15.7888 21.9808 10.7303L19.9849 13.1931C19.5692 16.0555 17.6175 18.5488 14.8098 19.5792L12.8117 22.0447ZM9.72714 4.3444C6.50138 5.3074 4.28838 8.1551 4.02392 11.382L2.13844 13.7087C1.25877 8.52208 4.55999 3.48102 9.75231 2.26931C10.3757 2.12384 10.999 2.03992 11.616 2.0136L9.72714 4.3444Z",
    className: "fill",
    fillOpacity: 0.5,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9767,
    cy: 12.0896,
    r: 6.02005,
    className: "fill",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.3b745f8ce1b1b9df1729ad3362772b05.svg";
export { ForwardRef as ReactComponent };